var _rect, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgQuestionMark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 23,
    rx: 16.5,
    fill: "white",
    stroke: "url(#paint0_linear)"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "-13 -11 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.69922 9.23828C2.69922 8.45898 2.7959 7.83789 2.98926 7.375C3.18262 6.91211 3.56348 6.40527 4.13184 5.85449C4.70605 5.29785 5.06934 4.90234 5.22168 4.66797C5.45605 4.31055 5.57324 3.92383 5.57324 3.50781C5.57324 2.95703 5.43555 2.53809 5.16016 2.25098C4.89062 1.95801 4.49219 1.81152 3.96484 1.81152C3.46094 1.81152 3.05371 1.95508 2.74316 2.24219C2.43848 2.52344 2.28613 2.90723 2.28613 3.39355H0.150391C0.162109 2.35645 0.513672 1.53613 1.20508 0.932617C1.90234 0.329102 2.82227 0.0273438 3.96484 0.0273438C5.14258 0.0273438 6.05957 0.326172 6.71582 0.923828C7.37793 1.52148 7.70898 2.35645 7.70898 3.42871C7.70898 4.38379 7.26367 5.32422 6.37305 6.25L5.29199 7.31348C4.90527 7.75293 4.70605 8.39453 4.69434 9.23828H2.69922ZM2.5498 11.9717C2.5498 11.626 2.6582 11.3477 2.875 11.1367C3.0918 10.9199 3.38477 10.8115 3.75391 10.8115C4.12891 10.8115 4.4248 10.9229 4.6416 11.1455C4.8584 11.3623 4.9668 11.6377 4.9668 11.9717C4.9668 12.2939 4.86133 12.5635 4.65039 12.7803C4.43945 12.9971 4.14062 13.1055 3.75391 13.1055C3.36719 13.1055 3.06836 12.9971 2.85742 12.7803C2.65234 12.5635 2.5498 12.2939 2.5498 11.9717Z",
    fill: "url(#paint0_linear)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 0,
    y1: 17,
    x2: 34,
    y2: 17,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F16152"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F99746"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionMark);
export default __webpack_public_path__ + "static/media/question-mark.488eea8fadb82bafa672b4fd2da69fe8.svg";
export { ForwardRef as ReactComponent };